export const accountSelector = state => {
  return state && state.account
}

export const isLoggedIn = state => state && state.account && !!state.account.sessionToken

export const isHRManager = state => state && state.account && state.account.user && state.account.user.ishrmanager

export const isAtoloAdmin = state => state && state.account && state.account.user && state.account.user.isetolo
